// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mn-0";
export var leftAlign = "_mn-4";
export var listItem = "_mn-2";
export var listItemWrapper = "_mn-1";
export var operationText = "_mn-3";